export default "__VITE_ASSET__OA0lTsW___"